import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import ApiService from '../../services/apiService';
import { FaSave, FaChevronLeft } from "react-icons/fa";
import { useLocation, useNavigate } from 'react-router-dom';

const ViewSupplier = () => {
    const apiService = new ApiService();
    const location = useLocation();
    const supplierData = location.state;

    const [supplierdata, setSupplierData] = useState({
        subgroup: null,
        accountcode: '',
        accountname: '',
        creditfacility: false,
        vatRegistered: false,
        createLedger: false,
        SapAccountCode: false,
        sgAccount: '',
        type: null,
        name: '',
        status: null,
        term: null,
        taxCode: null,
        chequeName: '',
        creditLimit: '',
        CreditDays: '',
        VatRegNo: '',
        TradeLicenceNo: '',
        Discount: '',
        PhonrNo: '',
        faxNo: '',
        mobileNo: '',
        email: '',
        web: '',
        address: '',
        line1: '',
        line2: '',
        country: null,
        city: null,

    });

    useEffect(() => {
        getItems();
    }, []);
    const getItems = async () => {
        try {
            const financialRes = await apiService.get('GET_FINANCIAL_YEAR');
            const selectedFinancialYear = financialRes?.data?.data?.find(po => po?.isActive === true);
            const params = new URLSearchParams();
            params.append('financialYear', selectedFinancialYear?.id);
            const response = await apiService.getApiParamater('GET_DROP_DOWN', `?${params.toString()}`)
            let data = response?.data?.data
            const res = await apiService.getApiParamater('GET_SUPPLIER_DATA', `${supplierData?.id}`)
            let supData = res?.data?.data
            let sup = supData?.supplier
            const selectedTax = data?.taxes?.find(dep => dep.id === sup?.taxCode.toString())
            setSupplierData({
                ...supplierdata,
                subgroup: { label: sup?.value || "", value: sup?.text || "" },
                accountcode: sup?.accountCode || "",
                accountname: sup?.accountName || "",
                creditfacility: sup?.hasCreditFacility || false,
                vatRegistered: false,
                createLedger: false,
                SapAccountCode: sup?.sapAccountCode || false,
                sgAccount: sup?.sGCode || '',
                type: { label: sup?.supplierType || "", value: sup?.supplierType || "" },
                name: sup?.supplierName || '',
                status: { label: sup?.status || "", value: sup?.status || "" },
                term: { label: sup?.paymentTerm || "", value: sup?.paymentTerm || "" },
                taxCode: { label: selectedTax?.name || "", value: selectedTax || "" },
                chequeName: sup?.chequePrintName || '',
                creditLimit: sup?.creditLimit || '',
                CreditDays: sup?.creditDays || '',
                VatRegNo: sup?.vATRegNo || '',
                TradeLicenceNo: sup?.tradeLicenceNo || '',
                Discount: sup?.discount || '',
                PhonrNo: sup?.phoneNo1 || '',
                faxNo: sup?.faxNo1 || '',
                mobileNo: sup?.mobileNo1 || '',
                email: sup?.email1 || '',
                web: sup?.web || '',
                address: sup?.address1 || '',
                line1: sup?.address2 || '',
                line2: sup?.address3 || '',
                country: { label: sup?.country || "", value: sup?.country || "" },
                city: { label: sup?.city || "", value: sup?.city || "" },
            });
        } catch (error) {
            console.error('Error fetching items:', error);
        }
    }

    const handleBackClick = () => {
        window.history.back();
    }
    return (
        <div className="p-4">
            <div className='border-box2 p-2 d-flex justify-content-between' style={{ borderRadius: "8px" }}>
                <div className='center'><h4 className='mainInvHead'>Supplier Details</h4></div>
                <div className='gap-3 d-flex'>
                    <div className='mainbtnSecondary flex-end gap-2' onClick={handleBackClick}>
                        <FaChevronLeft color='#fff' className='center mt-1 mx-2' />
                        <div className='center'>Back</div>
                    </div>
                </div>
            </div>
            <div className="cost-center-section mt-2">
                <div className={`border-box2 p-3`}>
                    <div className="form-group" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(400px, 1fr))', gap: '20px' }}>
                        <div className="d-flex">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Supplier Type *</label>
                            <Select
                                className="p-0 w-100"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 5,
                                    padding: 9,
                                })}
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                        color: state.isFocused ? "#000 " : "#000",
                                        ":hover": {
                                            backgroundColor: "#F5F5F5",
                                            color: "#000 ",
                                        },
                                    }),
                                }}
                                value={supplierdata.type} isDisabled
                            />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Supplier Name *</label>
                            <input type="text" className="p-2 form-Input w-75" value={supplierdata?.name} disabled name="name" />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="validationCustom18" className="form-label">Status *</label>
                            <Select
                                className="p-0 w-75"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 5,
                                    padding: 9,
                                })}
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                        color: state.isFocused ? "#000 " : "#000",
                                        ":hover": {
                                            backgroundColor: "#F5F5F5",
                                            color: "#000 ",
                                        },
                                    }),
                                }}
                                value={supplierdata.status} isDisabled
                            />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Payment Term</label>
                            <Select
                                className="p-0 w-100"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 5,
                                    padding: 9,
                                })}
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                        color: state.isFocused ? "#000 " : "#000",
                                        ":hover": {
                                            backgroundColor: "#F5F5F5",
                                            color: "#000 ",
                                        },
                                    }),
                                }}
                                value={supplierdata.term} isDisabled
                            />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="validationCustom19" className="form-label">Tax Code</label>
                            <Select className="p-0 w-100"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 5,
                                    padding: 9,
                                })}
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                        color: state.isFocused ? "#000 " : "#000",
                                        ":hover": {
                                            backgroundColor: "#F5F5F5",
                                            color: "#000 ",
                                        },
                                    }),
                                }}
                                value={supplierdata.taxCode} isDisabled
                            />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Cheque Name</label>
                            <input type="text" className="p-2 form-Input w-75" value={supplierdata?.chequeName} disabled name="chequeName" />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Credit Limit</label>
                            <input type="number" className="p-2 form-Input w-75" value={supplierdata?.creditLimit} disabled name="creditLimit" />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Credit Days</label>
                            <input type="number" className="p-2 form-Input w-75" value={supplierdata?.CreditDays} disabled name="CreditDays" />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Credit Facility</label>
                            <input
                                className="form-check-input"
                                type="checkbox"
                                id="active"
                                style={{ width: '20px', height: '20px' }}
                                checked={supplierdata.creditfacility} disabled
                            />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">VAT Reg No</label>
                            <input type="text" className="p-2 form-Input w-75" value={supplierdata?.VatRegNo} disabled name="VatRegNo" />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Vat Registered</label>
                            <input
                                className="form-check-input"
                                type="checkbox"
                                id="active"
                                style={{ width: '20px', height: '20px' }}
                                checked={supplierdata.vatRegistered} disabled
                            />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Trade Licence No</label>
                            <input type="text" className="p-2 form-Input w-75" value={supplierdata?.TradeLicenceNo} disabled name="TradeLicenceNo" />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Discount</label>
                            <input type="number" className="p-2 form-Input w-75" value={supplierdata?.Discount} disabled name="Discount" />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Phone No </label>
                            <input type="number" className="p-2 form-Input w-75" value={supplierdata?.PhonrNo} disabled name="PhonrNo" />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Fax No</label>
                            <input type="text" className="p-2 form-Input w-75" value={supplierdata?.faxNo} disabled name="faxNo" />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Mobile No</label>
                            <input type="number" className="p-2 form-Input w-75" value={supplierdata?.mobileNo} disabled name="mobileNo" />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Email</label>
                            <input type="email" className="p-2 form-Input w-75" value={supplierdata?.email} disabled name="email" />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Web</label>
                            <input type="url" className="p-2 form-Input w-75" value={supplierdata?.web} disabled name="web" />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Address</label>
                            <input type="text" className="p-2 form-Input w-75" value={supplierdata?.address} disabled name="address" />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">line 2 </label>
                            <input type="text" className="p-2 form-Input w-75" value={supplierdata?.line1} disabled name="line1" />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Line 3</label>
                            <input type="text" className="p-2 form-Input w-75" value={supplierdata?.line2} disabled name="line2" />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Country</label>
                            <Select
                                className="p-0 w-100"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 5,
                                    padding: 9,
                                })}
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                        color: state.isFocused ? "#000 " : "#000",
                                        ":hover": {
                                            backgroundColor: "#F5F5F5",
                                            color: "#000 ",
                                        },
                                    }),
                                }}
                                value={supplierdata.country} isDisabled
                            />
                        </div>

                        <div className="d-flex">
                            <label htmlFor="validationCustom19" className="form-label">City</label>
                            <Select className="p-0 w-100"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 5,
                                    padding: 9,
                                })}
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                        color: state.isFocused ? "#000 " : "#000",
                                        ":hover": {
                                            backgroundColor: "#F5F5F5",
                                            color: "#000 ",
                                        },
                                    }),
                                }}
                                value={supplierdata.city} isDisabled
                            />
                        </div>
                    </div>
                </div>
            </div >
        </div >
    );
};
export default ViewSupplier